const $ = jQuery.noConflict();

const anchorScroll = () => {
	// Cache DOM
	const $window = $(window);
	const $document = $(document);
	const body = $('html, body');
	const header = $('.header');

	// Bind Events
	$document.on('click', '.hero a[href^="#"]', function (e) {
		e.preventDefault();

		if ($window.width() >= 992) {
			body.animate({
				scrollTop: $($.attr(this, 'href')).offset().top
			}, 600);
		} else {
			body.animate({
				scrollTop: $($.attr(this, 'href')).offset().top - header.height()
			}, 600);
		}
	});
};

export default anchorScroll;
